import { Component, OnInit } from "@angular/core";
import { PodView } from "./pod-view.interface";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { Hyperlink } from "xlsx";
import { environment } from "src/environments/environment";

@Component(
    {
        selector: 'app-view-pod-modal',
        templateUrl: './view-pod-modal.component.html'
    })

export class ViewPodModal implements OnInit {
    public onClose: Subject<any>;
    constructor(public bsModalRf: BsModalRef) {
        this.onClose = new Subject();
    }
    pods: PodView[] = [];

    ngOnInit(): void { }

    toClose(): void {
        this.bsModalRf.hide();
    }

    onView(pod: PodView) {
        const podLink = document.createElement("a");
        podLink.href = `${environment.rootUrl}/uploads/${pod.imagePath}`;
        podLink.textContent = "Pod Image";
        podLink.target = "_blank";

        podLink.click();
    }
}
